export const WindowsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 13.5V20.934C21 21.1354 20.9594 21.3348 20.8807 21.5202C20.8019 21.7056 20.6867 21.8733 20.5417 22.0132C20.3968 22.1531 20.2252 22.2623 20.0371 22.3345C19.849 22.4066 19.6483 22.4401 19.447 22.433L19.314 22.422L12 21.508V13.5H21ZM10 13.5V21.258L4.752 20.602C4.26821 20.5415 3.82316 20.3064 3.50052 19.9409C3.17789 19.5753 2.99989 19.1045 3 18.617V13.5H10ZM19.314 2.57798C19.5139 2.55301 19.7167 2.56855 19.9105 2.62368C20.1042 2.6788 20.2849 2.77239 20.4416 2.89884C20.5984 3.0253 20.7281 3.18204 20.823 3.35971C20.9179 3.53738 20.9761 3.73235 20.994 3.93298L21 4.06598V11.5H12V3.49198L19.314 2.57798ZM10 3.74198V11.5H3V6.38298C2.99989 5.89542 3.17789 5.42461 3.50052 5.05907C3.82316 4.69353 4.26821 4.45843 4.752 4.39798L10 3.74198Z"
      fill="white"
    />
  </svg>
)
